import { Paper, Title, Text, Image, Group } from "@mantine/core";
import classes from "./AuthLayout.module.css";

const AuthLayout = ({
  children,
  title,
  subtitle = "Sign in to continue",
}) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.background}>
        <div className={classes.heroOverlay}>
          <Text className={classes.heroTitle}>
            Making the outdoors safe and secure
          </Text>
          <Text className={classes.heroSubtitle}>
            Adventure insurance and emergency support for operators worldwide.
          </Text>
        </div>
      </div>
      <div className={classes.formContainer}>
        <Paper className={classes.form} radius={0}>
          <Group className={classes.logo} justify="flex-end">
            <Image
              h={96}
              fit="contain"
              src="https://asc360.com/static/images/logo.png"
            ></Image>
          </Group>
          <Title order={2} className={classes.title} ta="start">
            {title}
          </Title>
          <Text className={classes.subtitle}>{subtitle}</Text>
          {children}
        </Paper>
      </div>
    </div>
  );
};

export default AuthLayout;
